/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetCloudResourceQuery, CloudResource } from "~/generated/graphql";

type Props = {
  resourceId: string;
};

export function useGetCloudResource({ resourceId }: Props) {
  const { data, loading, error } = useGetCloudResourceQuery({
    variables: { resourceId },
  });
  return {
    cloudResource: data?.cloudResource as CloudResource,
    loading,
    error,
  } as const;
}
